import React, { FC, useCallback, useRef } from 'react';
import { RowV2, ColV2, BoxV2, EmptyStateV2 } from '@cubeyou-team/hx-react-components';
import styled from 'styled-components';
import WorldMapChart from '../WorldMapChart';
import uniqid from 'uniqid';

type MultipleWorldMapChartProps = {
  data: any[];
  metric: string;
  emptyDataMessage: string;
  horizontalLayout: boolean;
  colors: any;
};

const StyledMultipleWorldMapChartWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #ffffff;
  padding: 10px;
`;
const MultipleWorldMapChart: FC<MultipleWorldMapChartProps> = ({
  data,
  metric,
  emptyDataMessage,
  horizontalLayout,
  colors
}) => {
  const chartId = useRef(uniqid());
  const isEmpty = !data || data.length === 0;
  const keys = (!isEmpty && Object.keys(data[0].metrics)) || [];

  const getWorldMapChartData = useCallback(
    (key) => {
      return data.map((d) => {
        return {
          id: d.id,
          insight_type: d.insight_type,
          label: d.label,
          pic: d.pic,
          ...d.metrics[key]
        };
      });
    },
    [data, metric]
  );

  if (isEmpty) {
    return (
      <StyledMultipleWorldMapChartWrapper>
        <BoxV2 minWidth='100%'>
          <EmptyStateV2
            icon='analytics'
            mainText={emptyDataMessage}
            size='large'
          />
        </BoxV2>
      </StyledMultipleWorldMapChartWrapper>
    );
  }
  return (
    <StyledMultipleWorldMapChartWrapper>
      <RowV2
        valign='equal'
        halign={horizontalLayout ? 'left' : 'center'}
        style={{ height: '100%' }}
      >
        {keys.map((key, index) => (
          <ColV2
            span={horizontalLayout && keys.length > 2 ? 4 : 6}
            key={`multiple-world-map-chart-${chartId.current}-${index}`}
          >
            <BoxV2 style={{ height: '100%' }}>
              <WorldMapChart
                data={getWorldMapChartData(key)}
                metric={metric}
                color={colors[key]}
                emptyDataMessage={emptyDataMessage}
              />
            </BoxV2>
          </ColV2>
        ))}
      </RowV2>
    </StyledMultipleWorldMapChartWrapper>
  );
};

export default MultipleWorldMapChart;
